import { render, staticRenderFns } from "./CarReturnLink.vue?vue&type=template&id=12631eb6"
import script from "./CarReturnLink.vue?vue&type=script&lang=js"
export * from "./CarReturnLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports